import { render } from "./VehicleSelector.vue?vue&type=template&id=515f11a7"
import script from "./VehicleSelector.vue?vue&type=script&lang=js"
export * from "./VehicleSelector.vue?vue&type=script&lang=js"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__